/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl';
import { useResize } from '../../hooks'
import { MenuLanguageAudio, CircProgressBar } from '../../components'
import { Container, BtnClose, ContainerProgressBar, MenuLanguageContainer, BtnPlayPauseContainer, ContainerHover, DescriptionContainer, TextDescription } from './index.styled'
import { ImPause2, ImPlay3, ImRadioChecked2 as BgHover } from 'react-icons/all'
import { CloseIcon } from '../icons'

const PlayerComponent = React.memo(({
  isPlaying = false, setPlaying = () => {}, isVisible = false,
  setVisible = () => {}, progress = 0, showTooltip = true
}) => {
  const intl = useIntl();
  const [ isHover, setIsHover ] = useState(true);
  const [ firstRun, setFirstRun ] = useState(true);
  const [ language, setLanguage ] = useState('en');
  

  const isMobile = useResize().isMobile;
  
  const changeLanguage = (lang) => {
    setLanguage(lang);
  }

  const getTitle = () => {
    let message = ""
    if(firstRun) {
      message = intl.formatMessage({ id: "show-video"})
    } else {
      message = isPlaying ? intl.formatMessage({ id: "stop"}) : intl.formatMessage({ id: "continue"});
    }
    return message;
  }

  const handleClickPlayPause = () => {
    setPlaying();
    if(firstRun) setFirstRun(false);
  }

  useEffect(() => {
    if(isMobile){
      !isHover && setIsHover(true);
    } 
  }, [isMobile])

  const renderIcon = () => isPlaying ? <ImPause2 size={24} className="btn-pause" /> : <ImPlay3 className="btn-play" size={28} />;
  return (
    <Container>
      {isPlaying && <BtnClose onClick={handleClickPlayPause}><CloseIcon /></BtnClose>}
      <BtnPlayPauseContainer className={firstRun ? 'bordered': ''}
                        // onMouseOver={() => !isMobile && setIsHover(true)}
                        // onMouseOut={() => !isMobile && setIsHover(false)}
                        >
        {renderIcon()}
        {(!isMobile && showTooltip === true) && 
        <MenuLanguageContainer className={isHover ? 'hover': ''}>
          <MenuLanguageAudio handlerChangeLanguage={changeLanguage} currentLanguage={language}/>
        </MenuLanguageContainer>
        }
        <ContainerHover onClick={handleClickPlayPause}>
          <BgHover className="act-hover" />
        </ContainerHover>
        {!firstRun &&
          <ContainerProgressBar>
            <CircProgressBar width={'100%'} value={progress} />
          </ContainerProgressBar>
         }
      </BtnPlayPauseContainer>
      {!isMobile &&
      <DescriptionContainer>
          <TextDescription className={!isHover ? 'hover': ''}>{getTitle()}</TextDescription>
      </DescriptionContainer>
      }
    </Container>
  )
})

PlayerComponent.propTypes = {
}

PlayerComponent.defaultProps = {
}

export default PlayerComponent